export const millimetersToCentimeters = (mm: number): number => mm / 10
